import { Pie } from '@ant-design/plots';
import { Empty } from 'antd';
import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

export const CirclePie = ({ summary }) => {
    const data = useMemo(
        () => [
            { type: 'Assessment', value: 0 },
            { type: 'Manual', value: 0 },
        ],
        []
    );

    useEffect(() => {
        if (summary) {
            data[0].value = summary?.assessmentChannel;
            data[1].value = summary?.manualChannel;
        }
    }, [data, summary]);

    const getColor = (type) => {
        switch (type) {
            case 'Assessment':
                return '#1CC5DC';
            case 'Manual':
                return '#FEDB39';
            default:
                return '#FEDB39';
        }
    };

    const config = useMemo(() => {
        return {
            data,
            color: ({ type }) => getColor(type),
            angleField: 'value',
            colorField: 'type',
            radius: 0.8,
            label: {
                text: (d) => `${d.type}\n ${d.value}`,
                position: 'spider',
            },
            legend: {
                color: {
                    title: false,
                    position: 'right',
                    rowPadding: 5,
                },
            },
            width: 80,
            height: 80,
            statistic: false,
        };
    }, [data]);

    const isEmptyData = data.every((item) => item.value === 0);

    if (isEmptyData) {
        return (
            <div className="text-center mt-10 text-base text-[#95A0A8]">
                ไม่พบข้อมูล
            </div>
        );
    }

    return <Pie {...config} />;
};

export const StatusPie = ({ summary }) => {
    const data = useMemo(
        () => [
            { type: 'New', title: 'ใหม่', value: 0 },
            { type: 'In Progress', title: 'อยู่ระหว่างการจัดการ', value: 0 },
            { type: 'Resolved', title: 'ได้รับการแก้ไขแล้ว', value: 0 },
            { type: 'Closed', title: 'ปฏิเสธ', value: 0 },
        ],
        []
    );

    useEffect(() => {
        if (summary) {
            data[0].value = summary?.dataBreachNew;
            data[1].value = summary?.dataBreachInprogress;
            data[2].value = summary?.dataBreachSolved;
            data[3].value = summary?.dataBreachReject;
        }
    }, [data, summary]);

    const getColor = (type) => {
        switch (type) {
            case 'New':
                return '#E9DEFA';
            case 'In Progress':
                return '#9E86FF';
            case 'Resolved':
                return '#826AF9';
            case 'Closed':
                return '#EFA6FF';
            default:
                return '#EFA6FF';
        }
    };

    const config = useMemo(() => {
        return {
            data,
            angleField: 'value',
            colorField: 'type',
            color: ({ type }) => getColor(type),
            radius: 1,
            width: 200,
            height: 200,
            innerRadius: 0.6,
            label: false,
            legend: false,
            interactions: [
                {
                    type: 'element-active',
                },
            ],
            statistic: false,
        };
    }, [data]);

    // If there is no data, display a message
    const isEmptyData = data.every((item) => item.value === 0);

    if (isEmptyData) {
        return (
            <Empty
                className="mt-20"
                description={
                    <span className="text-base text-[#95A0A8]">
                        ไม่พบข้อมูล
                    </span>
                }
            />
        );
    }

    return (
        <div className="mt-4">
            <Pie {...config} />
            <div className="mt-6">
                {data.map((item) => (
                    <div
                        key={item.type}
                        className="flex items-center justify-between"
                    >
                        <div className="flex items-center my-2">
                            <div
                                className="w-4 h-4 rounded-full mr-2"
                                style={{ backgroundColor: getColor(item.type) }}
                            />
                            <div>{item.title}</div>
                        </div>
                        <div className="text-[#808191]">{item.value}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

// Validate props
CirclePie.propTypes = {
    summary: PropTypes.object,
};

StatusPie.propTypes = {
    summary: PropTypes.object,
};
